import React, { Fragment, memo, useEffect,useRef, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faSave } from '@fortawesome/free-solid-svg-icons';
import MantTiposAsientosInt from './mantTiposAsientosInt.jsx';
import { SiteRutas } from '../../../request/RutasConfig.jsx';
//Invocaciones datos
import { TipoAsiento_Consulta_Request, TipoAsiento_Guardar_Request, TipoAsiento_Modificar_Request } from "../../../request/MantenimientosRequest.jsx"
import { useSessionStorage } from '../../../components/Util/Hooks/useSessionStorage.jsx';
//utilitarios
import { Notificacion } from '../../../components/Util/Notificacion/Notificacion.jsx';
import ModalSpinner from '../../../components/UI/modalSpinner/modalSpinner.jsx';

//Seguridad
import Session from '../../../components/Util/session/index.jsx';
import Config from '../../../components/Util/constantes.js';
import { Obtener_MenuOpciones_Lista_Request, Obtener_MenuNombre_Request } from "../../../request/MenuRequest.jsx"
import ModalSeguridad from "../../Seguridad/ModalSeguridad.jsx";
import optSeg from '../../../components/Util/seg-menu-opciones.js';

export function mantTiposAsientos(props) {
    let historyMenu = useHistory();
    const [token, setToken] = useSessionStorage('tokenCON', '');
    const [empresa, setEmpresa] = useSessionStorage('empresaCON', 0);
    const [usuario, setUsuario] = useSessionStorage('usuarioCON');
    const mounted = useRef();
    const [codigo, setCodigo] = useState('');
    const [id, setId] = useState('');

    const [spinnerModal, setSpinnerModal] = useState(undefined);
    const [spinnerLabel, setSpinnerLabel] = useState('');
    const [spinnerTipo, setSpinnerTipo] = useState(1);
    const botones = [
  
        {
            name: "btnHomeC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => volverAtras(),
            leyenda: "",
            iclase: faReply,
            tooltip: "Volver"
        },
        {
            name: "btnGuardar",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => ingresarDatos(),
            leyenda: "",
            iclase: faSave,
            tooltip: "Guardar"
        }
    ]
  
    const listaCampos = {
      ID: { value: 0, attributes: { readOnly: true, focus: false, label: 'Código', hidden: 'unset', Editando: false, maxLength: "20" } },
      Nombre: { value: "", attributes: { readOnly: false, focus: false, label: 'Nombre', hidden: 'unset', Editando: false, maxLength: "10" } },
      Mensual: { value: 'true', attributes: { readOnly: false, focus: false, label: 'Secuencia', hidden: 'unset' } },
      Auxiliar: { value: 'false', attributes: { readOnly: false, focus: false, label: 'Auxiliar', hidden: 'unset' } },
    }
  
    const listaMod = {
      "ID": "",
      "Empresa": "",
      "Nombre": "",
      "Mensual": "",
      "Auxiliar": "",
      "Fecha_Actualizacion": "",
      "Usuario_Modifica": "",
      "Usuario_Fecha_Actualiza": "",
    }
    const [datos, setDatos] = useState(listaCampos);
    const [listaModel, setListaModel] = useState(listaMod);
  
    //Seguridad
    const [usuarioS, setUsuarioS] = useSessionStorage('UsuarioSCON');
    const [menuId, setMenuId] = useState(0);
    const [menuOpciones, setMenuOpciones] = useState([]);
    const [showModalSeguridad, setShowModalSeguridad] = useState(false);
    const [opcionValidar, setOpcionValidar] = useState(0);
    const [opcionValidarNombre, setOpcionValidarNombre] = useState('');

    const spinnerModalMostrar = (pSpinnerModal, pSpinnerLabel, pSpinnerTipo) => {
        setSpinnerModal(pSpinnerModal);
        setSpinnerLabel(pSpinnerLabel);
        setSpinnerTipo(pSpinnerTipo);
    }

    const [listaMensual, setListaMensual] = useState([{ value: 'true', text: 'Mensual' }, { value: 'false', text: 'Anual' }]);
    const [selectedMensual, setSelectedMensual] = useState(listaMensual[0].value);

    const llenarListaDatos = () => {
        let _Campos = datos;
        let _Datos = listaModel;
        _Datos.ID = _Campos.ID.value;
        _Datos.Empresa = empresa;
        _Datos.Nombre = _Campos.Nombre.value;
        _Datos.Mensual = _Campos.Mensual.value;
        _Datos.Auxiliar = _Campos.Auxiliar.value;
        _Datos.Usuario_Modifica = usuario;

        return _Datos;
    }

    const asociarDatos = (pDatos) => {
        let _Campos = listaCampos;        
        _Campos.ID.value = pDatos.ID ;
        _Campos.Nombre.value = pDatos.Nombre;

        if (pDatos.Mensual) {
            _Campos.Mensual.value = 'true';
            setSelectedMensual('true');
        }
        else {
            _Campos.Mensual.value = 'false';
            setSelectedMensual('false');
        }

        if (pDatos.Auxiliar) {
            _Campos.Auxiliar.value = 'true';    
        }
        else {
            _Campos.Auxiliar.value = 'false';
        }

        return _Campos;
    }

    const volverAtras = () => {
        historyMenu.push(SiteRutas.TiposAsientos);
    }

    const cargarDatos = async () => {
        let spinnerLabel = 'Cargando datos...';
        spinnerModalMostrar(true, spinnerLabel, 3)

        let _id = (props.match.params.id == '0') ? '' : props.match.params.id;

        if (_id.length > 0) {
            const response = await TipoAsiento_Consulta_Request(token, empresa, _id);
            if (response.Exitoso) {
                const _datos = asociarDatos(response.Datos);
                setDatos(_datos);
                setCodigo(_id);
            }
            else {
                Notificacion.error(response.Mensaje);
                spinnerModalMostrar(false, '', 3)
                volverAtras();
            }
        } else {
            setDatos(listaCampos);
            setCodigo(_id);
        }

        setId(_id);

        const _MenuNomb = await cargarMenuNombre(Config.Modulo, optSeg.TMenuSistema.TiposdeCuentas.value);
        let _menuId = 0;

        if (_MenuNomb.ID != undefined) {
            _menuId = _MenuNomb.ID;
        }
        const _UsuarioS = usuarioS;
        let _menuOpciones = null;

        if (_menuId > 0) {
            _menuOpciones = await cargarMenuOpciones(Config.Modulo, _UsuarioS, _menuId);
        }
        setMenuId(_menuId), setMenuOpciones(_menuOpciones)

        spinnerModalMostrar(false, '', 3)
    }

    useEffect(() => {
  
      if (!mounted.current) {
          const carga = async () => {
              await cargarDatos()
          }
          carga();
          mounted.current = true;
      }
  
  }, [])
  
  
    //procesar datos
    const ingresarDatos = async () => {
        if (validarDatos()) {
            const _id = id;
            const optSegopt = optSeg.TOpciones_Menu;
            const _value = (_id > 0) ? optSegopt.Editar.value : optSegopt.Nuevo.value;
            let validar = validarMenuOpcion(_value);
            if (!validar) {
                await ingresarDatosSel();
            }
        }
  
    }
  
    const ingresarDatosSel = async () => {
        if (validarDatos()) {
          let spinnerLabel = id.length > 0 ? 'Actualizando datos' : 'Ingresando datos';
          spinnerModalMostrar(true, spinnerLabel, 3)
            const _data = llenarListaDatos();
            
            let resultado = '';
            
            console.log(`ingresarDatosSel _data:${JSON.stringify(_data)}`);
            if (codigo.length > 0) {
                resultado = await TipoAsiento_Modificar_Request(token, JSON.stringify(_data));
            }
            else {
                resultado = await TipoAsiento_Guardar_Request(token, JSON.stringify(_data));
            };
            spinnerModalMostrar(false, '', 3)
            if (resultado.Exitoso == true) {
                Notificacion.success('Se actualizó la información con éxito.');
            }
            else {
                if (isNaN(resultado.Mensaje.trim())) {
                    Notificacion.error(`Error: ${resultado.Mensaje}`);
                }
                else {
                    Notificacion.success('Se almacenó la información con éxito.');
                }
            }
            volverAtras();
        }
    }
  
    const validarDatos = () => {
        const _datos = datos;
        if (_datos.Nombre.value.trim().length == 0) {
            Notificacion.error('Error: Debe ingresar el dato: Nombre.');
            return false;
        }
        return true;
    }


    const onChangeInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        let newAttributes = datos[name].attributes;
        // newAttributes.focus = true; //Se asigna foco al componente
        const Datos = Object.assign({}, datos, { [name]: { value: value, attributes: newAttributes } })
        setDatos(Datos);
    }

    //Seguridad
    const cargarMenuOpciones = async (pModuloId, pUsuarioId, pMenuId) => {
        try {
  
            let listMO = await Obtener_MenuOpciones_Lista_Request(token, pModuloId, pUsuarioId, pMenuId);
            if (listMO.Exitoso === false) {
                return null;
            }
            return listMO.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuOpciones.`);
        }
    }
  
    const cargarMenuNombre = async (pModulo, pMenuNombre) => {
        try {
            let listMON = await Obtener_MenuNombre_Request(token, pModulo, pMenuNombre);
            if (listMON.Exitoso == false) {
                return null;
            }
            return listMON.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuNombre.`);
        }
    }
  
    const validarMenuOpcion = (pOpcion) => {
        let validar = false;
        let _menuOpciones = menuOpciones;
        const optSegopt = optSeg.TOpciones_Menu;
        let resultado = _menuOpciones.filter((item) => item.Opcion_Nombre == pOpcion);
        if (resultado.length > 0) {
            if (resultado[0].Opcion_Validar) {
                setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
                validar = true;
            }
        } else {
            setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
            validar = true;
            //Notificacion.error('No existe opción en la seguridad');
        }
        return validar;
    };
  
    const handleCerrarModal = () => setShowModalSeguridad(false);

    const handleRadioButton = (e, id) => {
        const name = id;
        const valor = e.target.value;    
        const _Datos = { ...datos };
        _Datos.Mensual.value = valor;
        setDatos(_Datos);

        if (name == "selectedMensual") {
            setSelectedMensual(valor);
        }      
    };    
  
    const onActionResultModal = (pValido) => {
        if (pValido) {
            let _OpcionNom = opcionValidarNombre;
            setShowModalSeguridad(false); setOpcionValidar(0); setOpcionValidarNombre('');
            const _optSegopt = optSeg.TOpciones_Menu;
            switch (_OpcionNom) {
                case _optSegopt.Nuevo.value:
                    ingresarDatosSel();
                    break;
                case _optSegopt.Editar.value:
                    ingresarDatosSel();
                    break;
                default:
                    break;
            }
        }
    }
  
  
    return (
        <Fragment>
            <MantTiposAsientosInt
                botones={botones}
                Titulo={'Tipo de Asiento'}
                Datos={datos}
                listaMensual={listaMensual}
                onChangeInput={onChangeInput}
                handleRadioButton={handleRadioButton}
                selectedMensual={selectedMensual}
            />
            <ModalSpinner
                selectedModal={spinnerModal}
                contentLabel={'spinnerModalProgress'}
                label={spinnerLabel}
                tipoSpinner={spinnerTipo}
            />
            <ModalSeguridad
                //token={this.props.token}
                modalTitle={'Requiere Permisos'}
                menuId={menuId}
                opcionId={opcionValidar}
                show={showModalSeguridad}
                onActionResult={onActionResultModal}
                onHide={handleCerrarModal}
            />
        </Fragment>
  );
};
export default withRouter(memo(mantTiposAsientos))